import React from 'react';
import ClientIndex from '../../components/client-index/ClientIndex';
import routes from '../../configs/routes';

export default () => {
  return <ClientIndex redirect={routes.ADMIN_CLIENT.EDIT} />;
};
